<template>
  <div
    :style="image"
    class="card-container"
    @click="goToResponsive">
    <div
      :class="categoryIcon"
      class="icon-card">
      <i
        v-if="category === 3 "
        class="icon-music-icon music-category background-category"/>
      <i
        v-else-if="category === 4 "
        class="icon-sports-icon sports-category background-category"/>
      <i
        v-else-if="category === 5 "
        class="icon-arts-icon arts-category background-category"/>
      <i
        v-else-if="category === 6 "
        class="icon-kids-icon kids-category background-category "/>
      <i
        v-else-if="category === 7 "
        class="icon-special-icon special-category background-category"/>
    </div>
    <div class="name-and-tags">
      <div
        class="to-event"
        @click="goTo">
        <div class="dates-card-event">
          <div>
            <span>Fechas</span><br>
            <span> {{ data.totalPresentations }}</span>
          </div>
          <div>
            <span>Próxima fecha</span><br>
            <slot name="mtNextDate"/>
          </div>
        </div>
        <div class="view-event">
          <span>CONSULTAR<i class="icon-chevron-right"/></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MtCardEvent',
  props: {
    data: {
      type: Object,
      required: true
    },
    category: {
      type: Number,
      required: true
    },
    nextDate: {
      type: String,
      default: ''
    }

  },
  data () {
    return {
      number: [],
      windowWidth: 0,
      categoryIcon: 'icon-' + this.category + '-identifier',
      imgCover: 'background-image: url(' + this.data.thumb + ')',
      date: moment
    }
  },
  computed: {
    image () {
      return {
        backgroundImage: 'url(' + this.data.thumbImage + ')'
      }
    }

  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  },
  methods: {
    goTo () {
      this.$router.push({ name: 'Eventos', params: { id: this.data.id } })
    },
    goToResponsive () {
      if (this.windowWidth <= 516) {
        this.$router.push({name: 'Eventos', params: {id: this.data.id}})
      }
    },
    /// ////GET PIXEL WIDTH/////////
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    }
  }
}
</script>

<style lang="scss" scoped>

  .card-container {
    width: 280px;
    height: 420px;
    position: relative;
    background-size: cover;
    background-position: center;
    border-radius: 2px;
    //margin: 0 auto;
    @media screen and (max-width: 1999px){
      margin: 0 auto;
    }
    @media #{$iPad} {
      margin: 0 auto;
    }
    @media #{$iPhone} {
      width: 100%;
    }
    @media #{$NoteS} {
      width: 100%;
    }
    .gradient{
      background: -webkit-linear-gradient(top, rgba(255,255,255,0.17) 0%, rgba(140,140,140,0) 65%, rgba(0,0,0,0.6) 100%);
      width: 100%;
      height: 100%;
      border-radius: 0 0 2px 2px;
    }
  }

  .icon-card {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 20px;
    left: 20px;
    -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
    -moz-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
    box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
    i {
      @include center-vertically();
      margin: 0 auto;
      color: white;
      font-size: 26px;
    }
  }

  .background-black-rgba{
    background-color: rgba(black, .5);
    color: white;
    @include font-primary(9px, regular);
    border-radius: 10px;
    padding: 3px 10px;
    margin-left: 5px;
  }
  .name-and-tags{
    position: absolute;
    width: 100%;
    bottom: 20px;
    padding: 0 20px 0 20px;
    .name-event{
      h1{
        @include font-primary(18px, light);
        color: white;
        margin: 0;
      }
    }
    .tag-event{
      span{
        color: white;
      }
    }
    .to-event{
      /*background-color: rgba(white, .2);
      border-radius: 2px;
      text-align: center;
      margin-top: 10px;
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;*/
      cursor: pointer;
      background-color: white;
      border-radius: 2px;
      padding: 11px 14px;
      display: flex;
      -webkit-box-shadow: 0 3px 10px 0 rgba(0,0,0,0.16);
      -moz-box-shadow: 0 3px 10px 0 rgba(0,0,0,0.16);
      box-shadow: 0 3px 10px 0 rgba(0,0,0,0.16);
      transition: all .3s ease-in-out;
      &:hover{
        -webkit-box-shadow: 0 6px 12px 0 rgba(0,0,0,0.16);
        -moz-box-shadow: 0 6px 12px 0 rgba(0,0,0,0.16);
        box-shadow: 0 6px 12px 0 rgba(0,0,0,0.16);
      }
      div{
        width: 60%;
        &:last-child{
          width: 40%;
        }
      }
      .dates-card-event{
        display: flex;
        div{
          width: 35%;
          &:last-child{
            width: 65%;
            border-right: 1px solid #E3E6EA;
          }
          span{
            color: #777777;
            @include font-primary(9px, bold);
            &:last-child{
              color: #444444;
              @include font-primary(13px, regular);
            }
          }
        }
      }
      .view-event{
        display: flex;
        align-items: center;
        justify-content: center;
        span{
          @include font-primary(11px, bold);
          color: #777777;
          margin: 0 auto;
          position: relative;
          i{
            transition: all .3s  ease-in-out;
            position: absolute;
            top: 3.5px;
            line-height: 10px;
            color: $roseHeader;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-card-event.vue